import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import {
  EdytujUstawieniaUzytkownikaRequest,
  UstawieniaUzytkownikaDto,
} from '@interfaces/administracja/systems/ustawienia-uzytkownika.interface';
import { AuthService } from '@services/auth.service';
import { BehaviorSubject, Observable, share } from 'rxjs';

const baseUrl = `${environment.apiUrl}/systems/ustawienia-uzytkownikow`;

@Injectable({
  providedIn: 'root',
})
export class UstawieniaUzytkownikaService {
  readonly ustawieniaUzytkownika = new BehaviorSubject<null | UstawieniaUzytkownikaDto>(null);

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
  ) {}

  initUstawienia(): void {
    this.getUserSettings().subscribe((newSettings) => {
      this.ustawieniaUzytkownika.next(newSettings);
    });
  }

  updateUstawienia(v: EdytujUstawieniaUzytkownikaRequest): Observable<null> {
    const sharedObs = this.updateUserSettings(v).pipe(share());
    sharedObs.subscribe(() => {
      this.getUserSettings().subscribe((newSettings) => {
        void this.authService.refreshToken().finally(() => {
          const oldLang = this.ustawieniaUzytkownika.value.jezykKod.split('-').at(0);
          this.ustawieniaUzytkownika.next(newSettings);

          const newLang = newSettings.jezykKod.split('-').at(0);
          const path = window.location.pathname.split('/');
          if ((environment.production || environment.angularConfiguration === 'testing') && path.at(1) === oldLang) {
            path[1] = newLang;
            window.location.pathname = path.join('/');
          }
        });
      });
    });
    return sharedObs;
  }

  private updateUserSettings(data: EdytujUstawieniaUzytkownikaRequest): Observable<null> {
    return this.http.put<null>(baseUrl, data);
  }

  private getUserSettings(): Observable<UstawieniaUzytkownikaDto> {
    return this.http.get<UstawieniaUzytkownikaDto>(baseUrl);
  }
}
